import { useMetricaUserId } from "@kupikupi/analytics/react";
import { useUserInfo } from "@kupikupi/api";
import { useAuthToken } from "../lib/auth";

/**
 * 把登录用户 id 关联到 Yandex Metrica(`setUserID`)。
 * 在 main.tsx 里 <MetricaScript/> 旁 mount 一次(需在 QueryClient + AuthBootstrap 内)。
 * 未登录是 no-op。与 web 端 metrica-user-id.tsx 对称。
 */
export function MetricaUserId(): null {
  const authToken = useAuthToken();
  const userInfo = useUserInfo(authToken);
  useMetricaUserId(userInfo.data?.id);
  return null;
}
